import { Form } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import { getUuid } from "../../../../helpers/functions";
import PageName from "./PageName";
import {
  AppDispatch,
  createSystemUiModule,
  createSystemUiModuleClear,
  createSystemUiModuleComponent,
  createSystemUiModuleComponentClear,
  createSystemUiModuleComponentRequest,
  createSystemUiModuleRequest,
  getSystemUiModuleListRequest,
  updateSystemUiModule,
  updateSystemUiModuleClear,
  updateSystemUiModuleComponent,
  updateSystemUiModuleComponentClear,
  updateSystemUiModuleComponentRequest,
  updateSystemUiModuleRequest,
} from "../../../../redux";

interface PageFormProps {
  close: () => void;
  actionType?: String;
  getId: string;
  actionItem: { name: string };
  setLoading: (loading: boolean) => void;
  setExpandedRowKey: any;
  linkType: string | null;
}

const PageForm: React.FC<PageFormProps> = ({
  close,
  actionType,
  getId,
  actionItem,
  setLoading,
  setExpandedRowKey,
  linkType,
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const [form] = Form.useForm();

  const { result, loading, error } = useSelector(
    createSystemUiModuleComponent
  );

  const {
    result: createResult,
    loading: createLoading,
    error: createError,
  } = useSelector(createSystemUiModule);

  const {
    result: updateResult,
    loading: updateLoading,
    error: updateError,
  } = useSelector(updateSystemUiModule);

  const {
    result: updateComponentResult,
    loading: updateComponentLoading,
    error: updateComponentError,
  } = useSelector(updateSystemUiModuleComponent);

  useEffect(() => {
    setLoading(
      createLoading || updateLoading || loading || updateComponentLoading
    );
  }, [createLoading, updateLoading, loading, updateComponentLoading]);

  useEffect(() => {
    if (actionType === "add_page" && createResult?.status === "success") {
      toast.success("Module created successfully");
      systemUiModuleList();
      close();
      dispatch(createSystemUiModuleClear());
    } else if (actionType === "add_page" && createError?.message) {
      toast.error(createError.message);
      systemUiModuleList();
      dispatch(createSystemUiModuleClear());
    } else if (
      actionType === "add_ui_component" &&
      result?.status === "success"
    ) {
      toast.success("Page Component created successfully");
      systemUiModuleList();
      close();
      setExpandedRowKey(null);
      dispatch(createSystemUiModuleComponentClear());
    } else if (
      actionType === "add_ui_component" &&
      error?.message === "error"
    ) {
      toast.error(error.message);
      systemUiModuleList();
      setExpandedRowKey(null);
      dispatch(createSystemUiModuleComponentClear());
    } else if (
      actionType === "edit_page" &&
      updateResult?.status === "success"
    ) {
      toast.success("Page updated successfully");
      systemUiModuleList();
      close();
      dispatch(updateSystemUiModuleClear());
    } else if (
      actionType === "edit_page" &&
      updateError?.message === "error"
    ) {
      toast.error(updateError.message);
      systemUiModuleList();
      dispatch(updateSystemUiModuleClear());
    } else if (
      actionType === "edit_page_component" &&
      updateComponentResult?.status === "success"
    ) {
      toast.success("Page component updated successfully");
      systemUiModuleList();
      close();
      setExpandedRowKey(null);
      dispatch(updateSystemUiModuleComponentClear());
    } else if (
      actionType === "edit_page_component" &&
      updateComponentError?.message
    ) {
      toast.error(updateComponentError.message);
      systemUiModuleList();
      setExpandedRowKey(null);
      dispatch(updateSystemUiModuleComponentClear());
    }
  }, [
    createResult,
    createError,
    result,
    error,
    updateResult,
    updateComponentResult,
    updateComponentError,
  ]);

  const systemUiModuleList = () => {
    dispatch(
      getSystemUiModuleListRequest({
        sort: [{ field: "name", order: "asc" }],
      })
    );
  };

  const createPage = (data: any) => {
    const variable = { data };
    dispatch(createSystemUiModuleRequest(variable));
  };

  const updatePage = (data: any) => {
    const variable = { data, id: getId };
    dispatch(updateSystemUiModuleRequest(variable));
  };

  const createPageComponent = (data: any) => {
    const variable = { data };
    dispatch(createSystemUiModuleComponentRequest(variable));
  };

  const updatePageComponent = (data: any) => {
    dispatch(updateSystemUiModuleComponentRequest({ data, id: getId }));
  };

  const onFinish = (values: any) => {
    const uuid = getUuid();
    if (actionType === "add_page") {
      createPage({ ...values, id: uuid });
    } else if (actionType === "add_ui_component") {
      createPageComponent({
        ...values,
        id: uuid,
        uiModuleId: getId,
      });
    } else if (actionType === "edit_page") {
      updatePage({
        ...values,
        id: getId,
      });
    } else if (actionType === "edit_page_component") {
      updatePageComponent({
        ...values,
        id: getId,
      });
    }
  };

  useEffect(() => {
    if (actionType === "add_page") {
      form?.resetFields();
      form.setFieldsValue({});
    } else {
      form.setFieldsValue({ name: actionItem.name });
    }
  }, [actionItem]);

  return (
    <div>
      <Form name="create page" onFinish={onFinish} id="page_form" form={form}>
        <PageName />
      </Form>
    </div>
  );
};

export default PageForm;
